module.exports = __webpack_public_path__ + "static/displayPic-53f5185e095d36bd46d2ba3871d7e119.jpg";